import script from "./NotifUser.vue?vue&type=script&setup=true&lang=js"
export * from "./NotifUser.vue?vue&type=script&setup=true&lang=js"

import "./NotifUser.vue?vue&type=style&index=0&id=23bee8bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23bee8bf"]])

export default __exports__